export const CAFE = {
  name: "Nomad Cafe",
  city: "Calgary, YYC",
  tagline: "Where YYC wanders, the brews follow.",
  address: "1134 12 Royal Vista Way NW",
  addressCity: "Calgary, AB T3R 0K4",
  phone: "(403) 453-9990",
  phoneHref: "tel:+14034539990",
  email: "info@nomadcafeyyc.ca",
  instagram: "https://www.instagram.com/nomadcafeyyc/?hl=en",
  instagramHandle: "@nomadcafeyyc",
  mapEmbed:
    "https://www.google.com/maps?q=1134+12+Royal+Vista+Way+NW+Calgary+AB&output=embed",
};

export const IMAGES = {
  hero: "/images/hero.jpg",
  latteArt: "/images/about-barista.jpg",
  barista: "/images/about-detail.jpg",
  espresso: "/images/order.jpg",
  igTiles: [
    "/images/ig-lineup.jpg",
    "/images/ig-pumpkin-cup.jpg",
    "/images/ig-spread.jpg",
    "/images/ig-mugs.jpg",
  ],
};

// Index 0 = Sunday, matching Date.getDay(). Minutes since midnight.
export const HOURS = [
  { day: "Sunday", open: 600, close: 1080, label: "10 AM – 6 PM" },
  { day: "Monday", open: 480, close: 1260, label: "8 AM – 9 PM" },
  { day: "Tuesday", open: 480, close: 1260, label: "8 AM – 9 PM" },
  { day: "Wednesday", open: 480, close: 1260, label: "8 AM – 9 PM" },
  { day: "Thursday", open: 480, close: 1260, label: "8 AM – 9 PM" },
  { day: "Friday", open: 480, close: 1320, label: "8 AM – 10 PM" },
  { day: "Saturday", open: 600, close: 1320, label: "10 AM – 10 PM" },
];

export const getCalgaryNow = () =>
  new Date(new Date().toLocaleString("en-US", { timeZone: "America/Edmonton" }));

export const isOpenNow = () => {
  const now = getCalgaryNow();
  const mins = now.getHours() * 60 + now.getMinutes();
  const today = HOURS[now.getDay()];
  return mins >= today.open && mins < today.close;
};

export const MENU = [
  {
    id: "coffee-tea",
    label: "Coffee & Tea",
    blurb: "Pulled fresh all day — try any drink iced.",
    items: [
      { name: "Americano", desc: "Bold and smooth, hot or iced", price: "4.50", tags: [] },
      { name: "Hot Chocolate", desc: "Rich, creamy, and comforting", price: "3.75 / 4.50", tags: [] },
      { name: "Latte", desc: "Double shot under silky steamed milk", price: "5.75 / 6.50", tags: [] },
      { name: "Flat White", desc: "Velvety microfoam over a double shot", price: "5.75 / 6.50", tags: [] },
      { name: "Traditional Macchiato", desc: "Espresso marked with a dollop of foam", price: "3.75", tags: [] },
      { name: "Traditional Cappuccino", desc: "Classic dry foam, dusted cocoa", price: "4.99", tags: [] },
      { name: "Mocha", desc: "Espresso, dark chocolate, steamed milk", price: "6.75 / 7.50", tags: [] },
      { name: "Chai Latte", desc: "House-spiced black tea with steamed milk", price: "5.75 / 6.50", tags: [] },
      { name: "London Fog", desc: "Earl Grey, vanilla, steamed milk", price: "5.75 / 6.50", tags: [] },
      { name: "Loose Leaf Tea", desc: "Ask us for today's selection", price: "4.99", tags: [] },
    ],
  },
  {
    id: "specialties",
    label: "Specialties",
    blurb: "The house signatures — every one $7.50.",
    items: [
      { name: "Nomad Cloud", desc: "Our signature cloud-topped creation", price: "7.50", tags: [] },
      { name: "Toasted Marshmallow", desc: "Campfire-sweet with torched marshmallow notes", price: "7.50", tags: [] },
      { name: "Desert Rose", desc: "Delicate rose, smooth and floral", price: "7.50", tags: [] },
      { name: "Spanish Latte", desc: "Condensed-milk sweetness over double espresso", price: "7.50", tags: [] },
      { name: "Maple Latte", desc: "Real maple, cozy and rich", price: "7.50", tags: [] },
      { name: "Strawberry Chai Iced", desc: "Spiced chai meets sweet strawberry", price: "7.50", tags: [] },
      { name: "Iced Tiramisu Latte", desc: "Espresso, mascarpone cream, cocoa dust", price: "7.50", tags: [] },
      { name: "Baklava Latte", desc: "Pistachio, honey, and warm spice", price: "7.50", tags: ["New"] },
    ],
  },
  {
    id: "matcha-refreshers",
    label: "Matcha & Refreshers",
    blurb: "Ceremonial matcha and iced refreshers — add caffeine for $1.50.",
    items: [
      { name: "Matcha Latte", desc: "Stone-ground matcha, whisked to order", price: "7.50 / 8.50", tags: [] },
      { name: "Iced Strawberry Matcha", desc: "Sweet strawberry layered under matcha", price: "8.50", tags: [] },
      { name: "Mango Breeze", desc: "Bright mango over ice", price: "5.00", tags: [] },
      { name: "Passionfruit Paradise", desc: "Tropical passionfruit, ice cold", price: "5.00", tags: [] },
      { name: "Lime Mojito", desc: "Zesty lime and fresh mint, zero proof", price: "5.00", tags: [] },
      { name: "Velvet Rose", desc: "Soft rose petals, lightly sweet", price: "5.00", tags: [] },
    ],
  },
  {
    id: "seasonal",
    label: "Seasonal",
    blurb: "The seasonal lineup — every one $7.50.",
    items: [
      { name: "Bedouin Pumpkin Latte", desc: "Pumpkin spice, espresso, toasted notes", price: "7.50", tags: ["Seasonal"] },
      { name: "Bedouin Pumpkin Chai", desc: "Spiced chai wrapped in pumpkin warmth", price: "7.50", tags: ["Seasonal"] },
      { name: "Sahara Blossom Latte", desc: "Floral, honeyed, and smooth", price: "7.50", tags: ["Seasonal"] },
      { name: "Sahara Blossom Matcha", desc: "Blossom-sweet matcha over ice", price: "7.50", tags: ["Seasonal"] },
    ],
  },
  {
    id: "waffles",
    label: "Waffles",
    blurb: "Made fresh to order, golden every time.",
    items: [
      { name: "Nomad Classic", desc: "The original — simple and golden", price: "9.99", tags: [] },
      { name: "Berry Bliss", desc: "Loaded with fresh berries and cream", price: "11.99", tags: [] },
      { name: "S'mores", desc: "Chocolate, marshmallow, graham crumble", price: "11.99", tags: [] },
      { name: "Biscoff Dream", desc: "Cookie butter, crushed Biscoff, drizzle", price: "11.99", tags: [] },
      { name: "Pumpkin Spice", desc: "The seasonal favourite", price: "11.99", tags: ["Seasonal"] },
    ],
  },
  {
    id: "all-day-bites",
    label: "All Day Bites",
    blurb: "Halal kitchen. Extras: egg +$2.00, meat +$2.50, bacon +$2.00.",
    items: [
      { name: "Breakfast Sandwich", desc: "The morning classic, made to order", price: "6.99", tags: [] },
      { name: "Nomad Club Sandwich", desc: "Our stacked house club", price: "13.50", tags: [] },
      { name: "Smoked Meat Sandwich", desc: "Piled high, deli style", price: "13.50", tags: [] },
      { name: "Caprese Sandwich", desc: "Fresh mozzarella, tomato, basil", price: "13.50", tags: [] },
      { name: "Grilled Cheese", desc: "Golden, gooey, griddled", price: "8.50", tags: [] },
      { name: "Beef-L-T", desc: "Beef, lettuce, tomato — the classic", price: "6.99", tags: [] },
      { name: "Classic Bagel", desc: "Toasted, with cream cheese", price: "6.50", tags: [] },
      { name: "Breakfast Bagel", desc: "Egg and more on a toasted bagel", price: "8.99", tags: [] },
      { name: "Pizza Bagel", desc: "Sauce, cheese, and a trip through the oven", price: "8.99", tags: [] },
      { name: "Za'atar Bagel", desc: "Olive oil and za'atar, toasted warm", price: "6.99", tags: [] },
    ],
  },
];

export const GALLERY = [
  { url: "/images/gallery-latte-art.jpg", title: "House Latte, Poured Slow", category: "Coffee", group: "brews" },
  { url: "/images/gallery-art-wall.jpg", title: "Our Local Artists' Wall", category: "The Space", group: "space" },
  { url: "/images/gallery-cake.jpg", title: "Pistachio Coffee Cake", category: "Bakery", group: "bakery" },
  { url: "/images/gallery-matcha.jpg", title: "Sahara Matcha on Ice", category: "Specialty", group: "brews" },
  { url: "/images/gallery-iced-pour.jpg", title: "Iced Latte, Poured to Order", category: "Coffee", group: "brews" },
  { url: "/images/gallery-book.jpg", title: "A Book & A Brew", category: "The Space", group: "space" },
  { url: "/images/gallery-sandwich.jpg", title: "Sandwich & Chips, Made Fresh", category: "Kitchen", group: "bakery" },
  { url: "/images/gallery-matcha-pair.jpg", title: "Matcha & Blossom, Side by Side", category: "Specialty", group: "brews" },
  { url: "/images/gallery-iced-latte.jpg", title: "Iced Latte at the Bar", category: "Coffee", group: "brews" },
  { url: "/images/gallery-duo.jpg", title: "The Iced Duo", category: "Specialty", group: "brews" },
];

export const NAV_LINKS = [
  { label: "Story", href: "#story", testid: "nav-link-story" },
  { label: "Menu", href: "#menu", testid: "nav-link-menu" },
  { label: "Gallery", href: "#gallery", testid: "nav-link-gallery" },
  { label: "Location", href: "#location", testid: "nav-link-location" },
  { label: "Contact", href: "#contact", testid: "nav-link-contact" },
];
